import { createAction, props } from '@ngrx/store';

export const CERTIFICA_CELLULARE = createAction(
  '[CERTIFICA CELLULARE] - submit',
  props<{ cellulare: string }>()
);

export const CERTIFICA_CELLULARE_SUCCESS = createAction(
  '[CERTIFICA CELLULARE] - success',
  props<{ esito: string; seed: string; cellulare: string; otpTtlSeconds?: number; msgCode?: string; maxTentativi?: number }>()
);

export const CERTIFICA_CELLULARE_FAIL = createAction(
  '[CERTIFICA CELLULARE] - fail',
  props<{ error: any }>()
);

export const CERTIFICA_CELLULARE_RESET = createAction(
  '[CERTIFICA CELLULARE] - reset'
);

export const CERTIFICA_CELLULARE_OTP = createAction(
  '[CERTIFICA CELLULARE] - submit otp',
  props<{ otp: string; seed: string; username: string; cellulare: string }>()
);

export const CERTIFICA_CELLULARE_OTP_SUCCESS = createAction(
  '[CERTIFICA CELLULARE] - otp success',
  props<{ esito: string; msgCode?: string; username: string | null }>()
);

export const CERTIFICA_CELLULARE_OTP_FAIL = createAction(
  '[CERTIFICA CELLULARE] - otp fail',
  props<{ error: any }>()
);
